export const UPLOAD_CSV_FILE_REQUEST = "UPLOAD_CSV_FILE_REQUEST";
export const UPLOAD_CSV_FILE_SUCCCESS = "UPLOAD_CSV_FILE_SUCCESS";
export const UPLOAD_CSV_FILE_FAILURE = "UPLOAD_CSV_FILE_FAILURE";